import { createSlice } from "@reduxjs/toolkit";

interface UiState {
  isSideMenuOpen: boolean;
  isProfileSheetOpen: boolean;
}

const initialState: UiState = {
  isSideMenuOpen: false,
  isProfileSheetOpen: false,
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    toggleSideMenu: (state) => {
      state.isSideMenuOpen = !state.isSideMenuOpen;
    },
    setSideMenu: (state, { payload }) => {
      state.isSideMenuOpen = payload;
    },
    setProfileSheetOpen: (state, action) => {
      state.isProfileSheetOpen = action.payload;
    },
  },
});

export const { toggleSideMenu, setProfileSheetOpen, setSideMenu } =
  uiSlice.actions;
export default uiSlice.reducer;
